"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Tour = _interopRequireDefault(require("./Tour"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = _Tour.default;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/reactour/dist/index.js
// module id = 1894
// module chunks = 0